<template>
    <div class="tags flex flex-align flex-wrap" v-if="tags">
        <template v-for="tag of tags">
            <div class="tag" :key="tag.id" @click="$emit('tag-clicked',tag)" :class="{active: activeId === tag.id}">
                {{ tag.title }}
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'Tag',
        props: {
            tags: Array,
            activeId : ''
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";
    .tag {
        padding: 8px 10px;
        border-radius: 3px;
        background-color: #EEEEEE;
        margin: 0 10px 10px 0;
        color: #636872;
        font-size: 14px;
        font-weight: 500;

        &.active {
            background-color: #3ED57F;
            color: #FFFFFF;
        }
    }
</style>
